"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
interface NotificationsStateAction {
  readonly label: string;
  readonly handler: () => void;
}
interface NotificationsStateMessageProps {
  readonly message: string;
  readonly action?: NotificationsStateAction | undefined;
}
export default function NotificationsStateMessage(t0) {
  const $ = _c(7);
  const {
    message,
    action
  } = t0;
  let t1;
  if ($[0] !== message) {
    t1 = <p className="tw-text-iron-300 tw-text-sm md:tw-text-base">{message}</p>;
    $[0] = message;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== action) {
    t2 = action ? <button type="button" onClick={action.handler} className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-iron-500 tw-bg-transparent tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-iron-100 desktop-hover:hover:tw-bg-iron-800 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-iron-300">{action.label}</button> : null;
    $[2] = action;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="tw-flex tw-flex-1 tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-text-center tw-min-h-full tw-px-4 tw-py-8">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}